const ROLES = {
  'User': 1001,
  'Admin': 2001,
  'Finance': 3001,
  'AdminRead':5001,
}

export {ROLES};